import styles from "./Banner.module.scss";
import classNames from "classnames";

type Props = {
  children?: React.ReactNode;
  className?: string;
  image?: string;
  imageVerticalOffset?: number;
}

const Banner: React.FC<Props> = ({ children, className, image, imageVerticalOffset = 50 }: Props) => {
  return (
    <div className={classNames(styles.bannerContainer, className)}>
      {image && <div className={styles.image} style={{backgroundImage: `url(${image})`, backgroundPosition: `center ${imageVerticalOffset}%`}}/>}
      <div className={styles.bannerInner}>
        {children}
      </div>

    </div>
  )
}

export default Banner;